import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import http from '../http';

const initialState = {
    data: [],
    loading:false,
    error:null
}

export const fetchNotice = createAsyncThunk('notification', async (requestData, thunkAPI) => {
    try {
        const response = await http.post('/v1/notice');
        return response.data; // 返回获取到的数据
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // 返回错误信息
    }
});

const slice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        // getData(state, action) {
        //     console.log('更新本地内容', action);


        // },

    },
    extraReducers: builder => {
        builder
            .addCase(fetchNotice.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNotice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.isSuccess == 1) {
                    state.data = action.payload.item;
                }
                else {
                    state.data = null;
                }

            })
            .addCase(fetchNotice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

// export const { updateSearch, updateRecommend } = slice.actions

export default slice.reducer